module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_scroll),
      expression: "is_scroll"
    }],
    staticClass: "page-component-up",
    on: {
      "click": _vm.Top
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-top"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "main-copyright"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/#/Integrated/recordQuery",
      "target": "bank"
    }
  }, [_vm._v(_vm._s(_vm.icpInfo))])]), _vm._v(" "), (_vm.policeInfo) ? _c('div', {
    staticClass: "main-copyright"
  }, [_c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo",
      "target": "bank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "margin-right": "6px"
    },
    attrs: {
      "src": require("./assets/img/police.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(_vm._s(_vm.policeInfo))])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18341d5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 518
// module chunks = 1